module.exports = __webpack_public_path__ + "img/exam_pass@2x.aa35093a.png";